<template lang="pug">
div
  b-row(v-show="isSubmitting")
    b-col
      b-card(class="py-5")
        loading(
          :active="true"
          :is-full-page="false"
          color="#498ceb"
        )
  ARRForm(
    v-show="!isSubmitting",
    :data="arrData",
    :current-arr-id="arrId",
    :is-edit="true",
    :on-save-draft="saveDraft",
    @submit="update"
  )
</template>

<script>
import ARRForm from '../shared/ARRForm.vue'
import useResidualRiskEdit from './useResidualRiskEdit'
import { onMounted } from '@vue/composition-api'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'ResidualRiskEdit',
  components: {
    ARRForm,
    Loading,
  },
  setup() {
    const { update, saveDraft, show, arrData, arrId, isSubmitting } = useResidualRiskEdit()

    onMounted(async () => {
      await show()
    })

    return {
      update,
      saveDraft,
      arrData,
      arrId,
      isSubmitting,
    }
  },
}
</script>
